
export class Withdrawal{
    /// Адрес кошелька куда выводится валюта
    public addressTo: string;
    /// Пользователь, выводящий валюту
    public userEmail: string;
    /// Дата вывода
    public date: Date;
    /// Сумма вывода
    public amount: number;
    /// Тип валюты
    public walletType: string;
    /// Свап в тип валюты
    public swapInTokenType: string;
    /// Статус проведения
    public status: string;
    /// Дата формата dd:MM:yyyy
    public stringDate: string;
    /// Ссылка на просмотр транзакции
    public linkTrHash: string;
    /// Переведенный на русский статус
    public stringStatus: string;

    telegramConfirmCount: number;
    /// Айди вывода 
    public id: number;

    constructor(_addressTo: string, _amount: number, _walletT: string, _date: number) {
        this.addressTo = _addressTo;
        this.amount = _amount;
        this.walletType = _walletT;
        this.date = new Date(_date);
    }

}



// WEBPACK FOOTER //
// ./src/app/core/models/withdraw.model.ts